import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useSnackbar } from '@lyearn/ui';
import { useRetakeQuizMutation } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/mutations/generated/retakeQuiz';
import { RetakeQuizInput } from '@/types/schema';

const useRetakeQuiz = ({ quizId, parentEntityId, isEmbed, isPreview }: RetakeQuizInput) => {
  const { t } = useTranslation();
  const [retakeQuizResponse, executeRetakeMutation] = useRetakeQuizMutation();
  const { showErrorSnackbar } = useSnackbar();

  const executeRetakeQuiz = useCallback(async () => {
    const response = await executeRetakeMutation({
      input: { parentEntityId, quizId, isEmbed, isPreview },
    });

    if (response.error) {
      showErrorSnackbar({ message: t('QuizPlayer:RetakeQuizError') });
    }

    return response;
  }, [executeRetakeMutation, isEmbed, isPreview, parentEntityId, quizId, showErrorSnackbar, t]);

  return {
    executeRetakeQuiz,
    fetching: retakeQuizResponse.fetching,
  };
};

export default useRetakeQuiz;
